import { BfiCustomStore, SectionHeader } from '../common/SharedComponents';
import store, { appraiserActions, searchActions } from '@apply/adminStore';
import { useSelector } from 'react-redux';
import AppraiserModal from './appraisers/modals/AppraiserModal';
import DeleteAppraiserModal from './appraisers/modals/DeleteAppraiserModal';
import RestoreAppraiserModal from './appraisers/modals/RestoreAppraiserModal';
import debounce from 'lodash.debounce';
import AppraisersTable from './appraisers/tables/AppraisersTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { Accordion } from '../common/components/Accordion';

function AppraisersSummary() {
    const searchState = useSelector((state) => state.searchState);
    const { dispatch } = store;
    const debouncedSearch = debounce(dispatch, 400);

    const activeAppraisers = new BfiCustomStore();
    const inactiveAppraisers = new BfiCustomStore();

    const _handleAddAppraiser = () => {
        dispatch(
            appraiserActions.setAppraiserModal({
                appraiserModal: { isOpen: true, appraiserId: 0 },
            })
        );
    };

    const _onSearchChange = (event) => {
        debouncedSearch(
            searchActions.setSearchText({
                searchText: {
                    ...searchState.searchText,
                    appraise: event.target.value,
                },
            })
        );
    };

    return (
        <>
            <SectionHeader
                title='Appraisers'
                buttonText='Add Appraiser'
                buttonCallback={_handleAddAppraiser}
            />
            <div
                className='main-content'
                style={{ padding: 0, backgroundColor: '#f4f4f4' }}
            >
                <div className='input-has-icon main-search'>
                    <input
                        type='search'
                        placeholder='Search to Filter Appraisers'
                        defaultValue={searchState.searchText?.appraiser}
                        onChange={_onSearchChange}
                    />
                    <FontAwesomeIcon
                        icon={faSearch}
                        aria-hidden='true'
                        className='icon'
                    />
                </div>
                <div className='scrollable-content'>
                    <div
                        className='applications accordion'
                        data-accordion=''
                        data-allow-all-closed='true'
                        data-multi-expand='true'
                    >
                        <Accordion
                            title='Active Appraisers'
                            subTitle=''
                            isExpanded={true}
                            isCollapsable={true}
                        >
                            <div className='card'>
                                <div className='card-section'>
                                    <AppraisersTable
                                        gridStore={activeAppraisers}
                                        inactive={false}
                                    />
                                </div>
                            </div>
                        </Accordion>
                        <Accordion
                            title='Inactive Appraisers'
                            subTitle=''
                            isExpanded={false}
                            isCollapsable={true}
                        >
                            <div className='card'>
                                <div className='card-section'>
                                    <AppraisersTable
                                        gridStore={inactiveAppraisers}
                                        inactive={true}
                                    />
                                </div>
                            </div>
                        </Accordion>
                    </div>
                </div>
            </div>
            <AppraiserModal />
            <DeleteAppraiserModal />
            <RestoreAppraiserModal />
        </>
    );
}

export default AppraisersSummary;
